export default {
    bindings: {
        isBestSellers: '<'
    },
    controller: 'dashboardController',
    template: require('../views/bestSellers.dashboard.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/dashboard/components/bestSellers.dashboard.component.js